import React, { useState, useEffect } from "react";
import { TimePicker } from "antd";
import moment from "moment";
import "antd/dist/reset.css";
const SelectTimePicker = ({
  readOnly,
  register,
  required,
  value,
  name,
  label,
  onChangeFunction,
  fromCity,
  toCity,
}) => {
  const [time, setTime] = useState(null);

  useEffect(() => {
    if (value) {
      const [hours, minutes] = value
        .split(" ")
        .filter((item) => !isNaN(item))
        .map(Number);
      if (!isNaN(hours) && !isNaN(minutes)) {
        setTime(moment({ hour: hours, minute: minutes }));
      }
    } else {
      setTime(null);
    }
  }, [value]);

  const handleTimeChange = (time) => {
    setTime(time);

    if (time && onChangeFunction) {
      const hours = time.hour();
      const minutes = time.minute();
      const formattedValue = `${hours} hr ${minutes} mins`;
      onChangeFunction(formattedValue);
    }
  };

  const handleOpenChange = (open) => {
    if (!open && time && onChangeFunction) {
      const hours = time.hour();
      const minutes = time.minute();
      const formattedValue = `${hours} hr ${minutes} mins`;
      onChangeFunction(formattedValue);
    }
  };

  const isRequired = (fromCity && toCity && Number(fromCity) !== Number(toCity)) || (required === true);

  return (
    <TimePicker
      {...register(`${name}`, {
        required: isRequired && !value ? `${label} is required!` : false, // Only required if cities differ
      })}
      value={time}
      showNow={false}
      disabled={readOnly}
      onChange={handleTimeChange}
      onOpenChange={handleOpenChange}
      format="HH:mm"
      use24Hours
      inputReadOnly
      placeholder="select duration"
      style={{ minHeight: "40px" }}
      className="w-full"
      renderExtraFooter={() => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            fontWeight: "bold",
          }}
        >
          <span>Hrs</span>
          <span>Mins</span>
        </div>
      )}
    />
  );
};

export default SelectTimePicker;
